export default {"src":"/encomendas-static/_next/static/media/web-cartoes.69a63cf5.svg","height":27,"width":276,"blurWidth":0,"blurHeight":0};